import { t } from '../utils/i18n';
/**
 * OrientationHint (now Portrait Blocker)
 *
 * Shows a fullscreen blocking overlay when the device is in portrait
 * orientation on mobile. Landscape-only game — portrait is not supported.
 *
 * The CSS class .portrait-blocker handles the media query:
 *   @media (orientation: portrait) and (max-width: 900px)
 * So the element is rendered always but only visible via CSS in portrait.
 */
export default function OrientationHint() {
    return (
        <div className="portrait-blocker" id="portrait-blocker">
            <div className="portrait-blocker-icon">📱</div>
            <div className="portrait-blocker-title">{t("ui.landscapeRequired")}</div>
            <div className="portrait-blocker-desc">
                {t("ui.landscapeOnly")}
            </div>
        </div>
    );
}
